<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedInstallationStatus"
    style="min-width: 220px;"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Status da UC
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
import { INSTALLATION_STATUS } from '../constants';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedInstallationStatus: this.value,
      options: [
        {
          value: 'WAITING_APPROVAL',
          text: INSTALLATION_STATUS.WAITING_APPROVAL,
        },
        { value: 'REJECTED', text: INSTALLATION_STATUS.REJECTED },
        { value: 'IN_ANALYSIS', text: INSTALLATION_STATUS.IN_ANALYSIS },
        { value: 'REFUSED', text: INSTALLATION_STATUS.REFUSED },
        {
          value: 'WAITING_CONNECTION',
          text: INSTALLATION_STATUS.WAITING_CONNECTION,
        },
        { value: 'CONNECTING', text: INSTALLATION_STATUS.CONNECTING },
        { value: 'ACTIVE', text: INSTALLATION_STATUS.ACTIVE },
        {
          value: 'INACTIVATION_REQUESTED',
          text: INSTALLATION_STATUS.INACTIVATION_REQUESTED,
        },
        { value: 'DISCONNECTED', text: INSTALLATION_STATUS.DISCONNECTED },
        { value: 'INACTIVE', text: INSTALLATION_STATUS.INACTIVE },
        {
          value: 'PENDING_INFORMATION',
          text: INSTALLATION_STATUS.PENDING_INFORMATION,
        },
        { value: 'DEBT', text: INSTALLATION_STATUS.DEBT },
        {
          value: 'SETTLEMENT',
          text: INSTALLATION_STATUS.SETTLEMENT,
        },
        {
          value: 'LOW_QUALITY_IMAGE',
          text: INSTALLATION_STATUS.LOW_QUALITY_IMAGE,
        },
        { value: 'WRONG_ADDRESS', text: INSTALLATION_STATUS.WRONG_ADDRESS },
        { value: 'WRONG_OWNER', text: INSTALLATION_STATUS.WRONG_OWNER },
        {
          value: 'CHANGING_PARTNER',
          text: INSTALLATION_STATUS.CHANGING_PARTNER,
        },
        {
          value: 'WRONG_CREDENTIALS',
          text: INSTALLATION_STATUS.WRONG_CREDENTIALS,
        },
        {
          value: 'DUPLICITY',
          text: INSTALLATION_STATUS.DUPLICITY,
        },
        {
          value: 'ENERGY_REPORT',
          text: INSTALLATION_STATUS.ENERGY_REPORT,
        },
      ],
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectedInstallationStatus);
    },
  },
};
</script>
